import '@/assets/styles/global/index.scss';

import { defaultConfig, plugin } from '@formkit/vue';
import { setWasmUrl } from '@lottiefiles/dotlottie-vue';
import dayjs from 'dayjs';
import isToday from 'dayjs/plugin/isToday';
import type { App as AppConfig } from 'vue';
import { createApp } from 'vue';
import { configure } from 'vue-gtag';
import { VueReCaptcha } from 'vue-recaptcha-v3';

import { LanguageService } from '@/services/Language';

import formKitConfig from '../formkit.config';
import { addVuePlugins } from '../vue-plugins';
import App from './App.vue';
import { getGoogleToken } from './constants/googleTokens';
import router from './router';

function initReCaptcha(app: AppConfig) {
  const siteKey = getGoogleToken('RECAPTCHA_V3');
  if (!siteKey) return;

  app.use(VueReCaptcha, {
    siteKey,
    loaderOptions: {
      useRecaptchaNet: false,
      autoHideBadge: true,
    },
  });
}

function init(app: AppConfig) {
  addVuePlugins(app, router);
  // @ts-ignore
  const formKit = defaultConfig(formKitConfig);
  app.use(plugin, formKit);

  // Initialize reCAPTCHA v3 with site key
  initReCaptcha(app);

  configure({
    tagId: getGoogleToken('ANALYTICS'),
  });

  router.isReady().then(() => app.mount('#app'));
  // eslint-disable-next-line no-console
  console.info('App version:', process.env.VUE_APP_VERSION);
  LanguageService.setUserStorageLanguage();
  setWasmUrl('/dotlottie-player.wasm');
}

init(createApp(App));

// DEBT: move out of there
dayjs.extend(isToday);
